import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecipientInfoService {
  recipientId: string;
  mainBankId: string;
  intermediaryBankId: string;
  isNotified: boolean;
  recipientStatus: number;
  isIntermediary: boolean;
  mainBankStatus: boolean;
  mainReference: string;
  intermediaryStatus: boolean;
  intermediaryReference: string;
  isDelete: boolean;
  recipientMandateExist: any;
}
